import { Tooltip } from 'antd';
import { limit, localStorageConstant } from '../constants/appConstants';
import moment from 'moment';

export const getTokenFromLocalStorage = () => {
  const token = JSON.parse(localStorage.getItem(localStorageConstant.tokenKey));
  return token;
};

export const getTempTokenFromLocalStorage = () => {
  const tempToken = JSON.parse(localStorage.getItem(localStorageConstant.tempTokenKey));
  return tempToken;
};

export const getUserFromLocalStorage = () => {
  const user = JSON.parse(localStorage.getItem(localStorageConstant.userKey));
  return user;
};

export const setTokenLocalStorage = (token) => {
  localStorage.setItem(localStorageConstant.tokenKey, JSON.stringify(token));
};

export const getRefreshTokenFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem(localStorageConstant.refreshKey));
};

export const setRefreshTokenLocalStorage = (token) => {
  localStorage.setItem(localStorageConstant.refreshKey, JSON.stringify(token));
};

export const setTempTokenLocalStorage = (tempToken) => {
  localStorage.setItem(localStorageConstant.tempTokenKey, JSON.stringify(tempToken));
};

export const setUserLocalStorage = (user) => {
  localStorage.setItem(localStorageConstant.userKey, JSON.stringify(user));
};

export const emptyLocalStorage = () => {
  localStorage.removeItem(localStorageConstant.tokenKey);
  localStorage.removeItem(localStorageConstant.tempTokenKey);
  localStorage.removeItem(localStorageConstant.refreshKey);
  localStorage.removeItem(localStorageConstant.userKey);
};

export const createImagePreview = (file) => {
  return URL.createObjectURL(file);
};

export const isFileObejct = (item) => {
  if (item instanceof File) {
    return true;
  } else {
    return false;
  }
};

export const getQueryParams = (search, limit, page, otherParams = {}) => {
  const query = {};
  Object.entries(otherParams).forEach(([key, value]) => {
    if (value) {
      query[key] = value;
    }
  });

  if (search) {
    query.search = search;
  } else {
    query.limit = limit;
    query.offset = page;
  }
  return query;
};

export const shortenString = (str, len) => {
  if (str.length > len) {
    return <Tooltip title={str}>{str.slice(0, len) + '...'}</Tooltip>;
  } else {
    return str;
  }
};

export const handleCurrPage = (currPage) => {
  return currPage == 0 ? 1 : currPage / limit + 1;
};

export const handleSetPage = (currPage) => {
  return limit * (currPage == 1 ? 0 : currPage - 1);
};

export const handleSno = (search, offset, index) => {
  if (search) {
    return index + 1;
  } else {
    return offset + index + 1;
  }
};

export const getFormattedDate = (date) => {
  return moment.format(date, 'M/D/YY');
};

export const objectToQueryParams = (obj) => {
  return Object.keys(obj)
    .reduce((acc, key) => {
      if (obj[key]) {
        acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
      }
      return acc;
    }, [])
    .join('&');
};
